import React from 'react';
import './PC.css';
import adidas from '../../img/pc/adidas.png'
import Bocato from '../../img/pc/Bocato.png'
import CapitalOne from '../../img/pc/CapitalOne.png'
import Cermak from '../../img/pc/Cermak.png'
import Colman from '../../img/pc/Colman.png'
import Freniche from '../../img/pc/Freniche.png'
import MongoDB from '../../img/pc/MongoDB.png'
import Piper from '../../img/pc/Piper.png'
import Porsche from '../../img/pc/Porsche.png'
import ScalableCapital from '../../img/pc/ScalableCapital.png'
import Skyscanner from '../../img/pc/Skyscanner.png'
import Vercauteren from '../../img/pc/Vercauteren.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speakers: [
        {
          photo: Freniche,
          name: 'Diego Freniche',
          position: 'Developer Advocate',
          tw: 'https://twitter.com/dfreniche',
          logo: MongoDB,
        },
        {
          photo: Bocato,
          name: 'Eduardo Bocato',
          position: 'iOS Lead',
          ln: 'https://www.linkedin.com/in/bocato/',
          tw: 'http://twitter.com/dubocato',
          github: 'http://github.com/bocato',
          logo: adidas,
        },
        {
          photo: Colman,
          name: 'Dan Colman',
          position: 'iOS Engineer',
          ln: 'https://www.linkedin.com/in/dancolmanios/',
          tw: 'https://twitter.com/hotavocadoapps',
          logo: CapitalOne,
        },
        {
          photo: Cermak,
          name: 'Cyril Cermak',
          position: 'iOS System Architect',
          ln: 'https://www.linkedin.com/in/cyril-cermak-210a8b6b/',
          logo: Porsche,
        },
        {
          photo: Vercauteren,
          name: 'Gert-Jan Vercauteren',
          position: 'Lead accessibility engineer',
          ln: 'https://www.linkedin.com/in/gertjanvercauteren/',
          logo: Skyscanner,
        },
        {
          photo: Piper,
          name: 'David Piper',
          position: 'Software Engineer',
          tw: 'https://twitter.com/HeyDaveTheDev',
          logo: ScalableCapital,
        },
      ],
      isHovered: false,
      hoveredPC: [],
    }
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseEnter = (name) => {
    this.setState({ isHovered: true })
    if (this.state.hoveredPC.indexOf(name) > -1) {
      let index = this.state.hoveredPC.indexOf(name);
      if (index !== -1) {
        this.setState({
          hoveredPC: this.state.hoveredPC.filter(function (item) {
            return item !== name
          })
        });
      }
    } else {
      this.setState({ hoveredPC: [...this.state.hoveredPC, name] })
    }
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false })
    this.setState({ hoveredPC: [] });
  };

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className='pc_info' style={{ backgroundImage: `url(${item.photo}` }}>
          <p className="pc_name p1">{item.name}</p>
          <p className="pc_position p2 grey">{item.position}</p>
          <img className='pc_logo' src={item.logo} alt="" />
          <div className="pc_links">
            {item.fb && <a className="social_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="social_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="social_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.youtube && <a className="social_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="social_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc_wrap pc_wrap--mb" id='speakers'>
        <div className='container pc'>
          <h2 className='pc_title pc_main'>Speakers from previous event</h2>
          <div className='pc_block'>
            {this.state.speakers.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </div>
    )
  }
}